import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { SMLRouteNames } from '../../../../routing/sml/SMLRoutes';
import { isNavItemActive, SMLNavGroup } from '../smlNavigation';
import { SMLNavBadges } from '../hooks/useNavBadges';
import { useNavUsageCaptions } from '../hooks/useNavUsageCaptions';
import { MobileSheet } from './MobileSheet';
import { MobileHubTile } from './MobileHubTile';
import styles from './MobileGroupSheet.module.scss';

interface MobileGroupSheetProps {
  id: string;
  group: SMLNavGroup;
  screen: SMLRouteNames | undefined;
  badges: SMLNavBadges;
  params?: Record<string, string>;
  onClose: () => void;
}

/** Design b2, b3, b6: the hub of one group — its name, one line, and a tile per destination. */
const MobileGroupSheetComponent: React.FC<MobileGroupSheetProps> = ({ id, group, screen, badges, params, onClose }) => {
  const intl = useIntl();
  const usage = useNavUsageCaptions();

  return (
    <MobileSheet
      id={id}
      title={intl.formatMessage(group.label)}
      description={intl.formatMessage(group.description)}
      onClose={onClose}
    >
      <ul className={styles.tiles}>
        {group.items.map((item) => (
          <MobileHubTile
            key={item.id}
            item={item}
            isActive={isNavItemActive(item, screen)}
            badge={badges.items[item.id]}
            usage={item.usage === undefined ? undefined : usage[item.usage]}
            params={params}
            onNavigate={onClose}
          />
        ))}
      </ul>
    </MobileSheet>
  );
};

export const MobileGroupSheet = TypedMemo(MobileGroupSheetComponent);
